import gql from 'graphql-tag';
import {
  FULL_FRAGMENT,
  BASE_FRAGMENT,
  CREW_FRAGMENT,
  PROPERTY_FRAGMENT,
  CLIENT_FRAGMENT,
} from './fragments';

export const GET_ESTIMATES = gql`
  query getEstimates($data: SearchEstimatesInput) {
    getEstimates(data: $data) {
      ... on GetEstimates {
        message
        version
        paginationInfo {
          currentPage
          totalPages
          nextPage
          prevPage
          totalRecords
          totalReturnedRecords
          startIndex
          endIndex
        }
        estimates {
          ...EstimateBaseFragment
          messages {
            id
          }
          crew {
            ...CrewFragment
          }
          property {
            ...PropertyFragment
          }
          client {
            ...ClientFragment
          }
        }
      }
      ... on Error {
        errorCode
        message
      }
    }
  }
  ${BASE_FRAGMENT}
  ${CREW_FRAGMENT}
  ${PROPERTY_FRAGMENT}
  ${CLIENT_FRAGMENT}
`;

export const GET_ESTIMATE_DETAILS = gql`
  query getEstimate($id: ID!) {
    getEstimate(id: $id) {
      ... on GetEstimate {
        message
        version
        estimate {
          ...EstimateFullFragment
        }
      }
      ... on Error {
        errorCode
        message
      }
    }
  }
  ${FULL_FRAGMENT}
`;

export const GET_ESTIMATE_PDF = gql`
  query getEstimatePDF($id: ID!) {
    getEstimatePDF(id: $id) {
      ... on GetEstimatePDF {
        estimatePDF {
          pdf
        }
      }
      ... on Error {
        errorCode
        message
      }
    }
  }
`;
